export const LOGIN_HISTORY = 'login-history';

export const LAST_24_HOURS_VALUE = 1;
export const LAST_WEEK_VALUE = 7;
export const LAST_MONTH_VALUE = 30;
export const LAST_THREE_MONTHS_VALUE = 90;
export const LAST_SIX_MONTHS_VALUE = 180;
export const ANOTHER_PERIOD_VALUE = -1;

export const PERIODS = [
    { label: 'filter.periods.day', value: LAST_24_HOURS_VALUE },
    { label: 'filter.periods.week', value: LAST_WEEK_VALUE },
    { label: 'filter.periods.month', value: LAST_MONTH_VALUE },
    { label: 'filter.periods.threeMonths', value: LAST_THREE_MONTHS_VALUE },
    { label: 'filter.periods.sixMonths', value: LAST_SIX_MONTHS_VALUE },
    { label: 'filter.periods.anotherPeriod', value: ANOTHER_PERIOD_VALUE }
];
